import React, { useState, Suspense } from 'react';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

const InitialPage = React.lazy(() => import('./InitialPage').then(module => ({ default: module.InitialPage })));
const Holder = React.lazy(() => import('./Holder'));
const BookingStatuspage = React.lazy(() => import('./BookingStatuspage'));
const NotFoundPage = React.lazy(() => import('./Components/404'));

function App() {
  const [InitialPageDate, setInitialPageDate] = useState('');
  const [InitialPageResort, setInitialPageResort] = useState('');
  const [campaignId,setCampaignId] = useState('');

  return (
    <Router basename="/">
      <div>
        <ToastContainer position="top-right" autoClose={4000} />
        <ToastContainer
  containerId="colored"
  theme="colored"
  position="top-center"
  autoClose={5000}
/>
        <Suspense fallback={<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',fontSize:'24px',color:'#555'}}>Loading...</div>}>
          <Routes>
            {/* Route for initial page */}
            <Route
              path="/"
              element={
                <InitialPage
                  setInitialPageDate={setInitialPageDate}
                  setInitialPageResort={setInitialPageResort}
                  setCampaignId={setCampaignId}
                />
              }
            />

            {/* Route for booking page with Holder component */}
            <Route
              path="/booking"
              element={<Holder initialPageDate={InitialPageDate} initialPageResort={InitialPageResort} campaignId={campaignId}/>}
            />

            {/* Route for booking page with Holder component */}
            <Route
              path="/confirmation"
              element={<BookingStatuspage/>}
            />

            <Route
              path="/404"
              element={<NotFoundPage/>}
            />

            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
